import PropTypes from "prop-types";
import React, { PureComponent } from "react";

export default class Modal extends PureComponent {
    static propTypes = {
        onClose: PropTypes.func.isRequired,
        show: PropTypes.bool.isRequired,
        className: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.state = {            
        }
    }

    componentDidMount() {
        document.addEventListener("keydown", this._handleEsc, false);
        if (window.matchMedia("(max-width: 768px)").matches) {
            const top = document.body.scrollTop;
            this.setState({ isMobile: true, top });
        }
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this._handleEsc, false);
    }

    _handleEsc = (e) => {
        if (e.keyCode === 27) {
            this.props.onClose();
        }
    }

    render() {

        const showHideClassName = (this.props.show ? "modal show " : "modal hide ") + this.props.className;
        return (
            <div className={showHideClassName}>				                
                <div className="modal-content">             
                    <button type="button" className="modal-close-btn" onClick={this.props.onClose}>×</button>
                    {this.props.children}
                </div>
			</div>
        );
    }
}